<template>

<b-container id="SurveyFinished" class="text-center mt-5">
    <b-row>
        <b-col>
            <h1 class="display-4">Captura completa</h1>
            <p class="lead">Gracias por llenar éste breve cuestionario. Ya puedes cerrar ésta ventana.</p>
            <hr>
            <b-button variant="primary" :href="mainSite">Ir al Sitio Principal</b-button>
            <hr>
            <p class="note">
                Para corregir o actualizar tu expediente, usa la misma liga.
            </p>
        </b-col>
    </b-row>
</b-container>

</template>

<script>
import {publicWebURI} from '@/apiConfig'
export default {
    name: 'SurveyFinished',
    props: {
        mainSite: {
            type: String, 
            default: ( ) =>  publicWebURI
        }
    }
}
</script>